import React from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Paper,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup
} from "@mui/material";

function MedicalRecord({ form, handleChange }) {

  const medicalHistoryOptions = [
    "Polio",
    "Hepatitis",
    "Mumps",
    "Whooping Cough",
    "German Measles",
    "Red Measles",
    "Rheumatic Fever",
    "Visual Impairment",
    "Epilepsy",
    "Mild Autism",
    "Learning Disability",
    "Hearing Impairment",
    "Developmental Delay",
    "Muscular Dystrophy",
    "Juvenile Diabetes",
    "Asthma"
  ];

  const handleHistoryChange = (event) => {
    const value = event.target.name;
    const currentHistory = form.medicalHistory || [];

    const updatedHistory = currentHistory.includes(value)
      ? currentHistory.filter((item) => item !== value)
      : [...currentHistory, value];

    handleChange("medicalHistory", updatedHistory);
  };

  return (
    <Box  display="flex" justifyContent="center" bgcolor="#f4f6f8">

      <Paper sx={{  p: 1 }}>

        {/* HEADER */}
        <Box sx={{ background: "teal", color: "#fff", p: 1, mb: 3 }}>
          <Typography fontWeight="bold">
            8) Medical Record (Please fill in BLOCK CAPITAL LETTERS ONLY)
          </Typography>
        </Box>

        <Grid container spacing={2}>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name of Child's Doctor"
              size="small"
              value={form.doctorName || ""}
              onChange={(e)=>handleChange("doctorName", e.target.value.toUpperCase())}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Clinic Address"
              size="small"
              value={form.clinicAddress || ""}
              onChange={(e)=>handleChange("clinicAddress", e.target.value.toUpperCase())}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography>Has the child ever been hospitalized?</Typography>

            <RadioGroup
              row
              value={form.hospitalized || ""}
              onChange={(e)=>handleChange("hospitalized", e.target.value)}
            >
              <FormControlLabel value="YES" control={<Radio />} label="Yes" />
              <FormControlLabel value="NO" control={<Radio />} label="No" />
            </RadioGroup>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Year"
              size="small"
              value={form.year || ""}
              onChange={(e)=>handleChange("year", e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Reason"
              size="small"
              value={form.reason || ""}
              onChange={(e)=>handleChange("reason", e.target.value.toUpperCase())}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Handicaps (eye, ears, feet, etc)"
              size="small"
              value={form.handicaps || ""}
              onChange={(e)=>handleChange("handicaps", e.target.value.toUpperCase())}
            />
          </Grid>

          <Grid item xs={8}>
            <TextField
              fullWidth
              label="Allergies"
              size="small"
              value={form.allergies || ""}
              onChange={(e)=>handleChange("allergies", e.target.value.toUpperCase())}
            />
          </Grid>

          <Grid item xs={4}>
            <TextField
              fullWidth
              label="Blood Group"
              size="small"
              value={form.bloodGroup || ""}
              onChange={(e)=>handleChange("bloodGroup", e.target.value.toUpperCase())}
            />
          </Grid>

        </Grid>

        {/* MEDICAL HISTORY */}

        <Typography mt={4} fontWeight="bold">
          Medical History
        </Typography>

        <FormGroup>
          <Grid container>
            {medicalHistoryOptions.map((item, index) => (
              <Grid item xs={3} key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(form.medicalHistory || []).includes(item)}
                      onChange={handleHistoryChange}
                      name={item}
                    />
                  }
                  label={item}
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>

        <Grid container spacing={2} mt={2}>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Any Other Medical History"
              size="small"
              value={form.otherHistory || ""}
              onChange={(e)=>handleChange("otherHistory", e.target.value.toUpperCase())}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Special Learning Needs (Dyslexia, ADHD, Autism etc)"
              size="small"
              value={form.specialNeeds || ""}
              onChange={(e)=>handleChange("specialNeeds", e.target.value.toUpperCase())}
            />
          </Grid>

        </Grid>

      </Paper>

    </Box>
  );
}

export default MedicalRecord;